import PropTypes from "prop-types";

// Layouts
import EmptyBody from "@/Layouts/components/Basics/EmptyBody";
import PayPlanHistoryAssignmentsLoader from "@/Layouts/components/Skeletons/PayPlanHistoryAssigmentLoader";

// Images
import empty from "@/assets/images/commons/empty.png";
import emptyTable from "@/assets/images/commons/empty_table.png";
import RoundedBox from "@/Layouts/components/Basics/RoundedBox";
import { Grid } from "@mui/material";

const RenderContent = (props) => {
	const { children, selected = null, filteredData = [], loading = false } = props;

	const emptyMessage = !selected ? "Select a Pay Plan." : "No history for this Pay Plan.";

	if (loading) {
		return <PayPlanHistoryAssignmentsLoader />;
	}

	if (!selected) {
		return (
			<EmptyBody
				image={selected ? emptyTable : empty}
				title={emptyMessage}
				bodyHeight="510px"
				sx={{
					width: "100%",
					boxShadow: "none !important",
				}}
			/>
		);
	}

	return <>{children}</>;
};
RenderContent.propTypes = {
	children: PropTypes.node,
	selected: PropTypes.object,
	filteredData: PropTypes.array,
	loading: PropTypes.bool,
};

export default function SelectedItemContent(props) {
	return (
		<Grid className="w-[100%]">
			<RenderContent {...props} />
		</Grid>
	);
}
SelectedItemContent.propTypes = {
	children: PropTypes.node,
	selected: PropTypes.object,
	filteredData: PropTypes.array,
	searchValue: PropTypes.string,
	loading: PropTypes.bool,
};
